import React, { useState } from "react";
import { useIntl } from "react-intl";
import { AlertTriangle, CopyV2 } from "@piiqtechnologies/svg-icons";
import { PeekAlert, PeekBox, PeekButton, PeekStack, PeekTypography } from "@piiqtechnologies/ui-components";
import messages from "../../messages.i18n";
import { CustomSubtopicsWarningDialog } from "./CustomSubtopicsWarningDialog";
const CustomSubtopicWarningIcon = () => {
    return (React.createElement(PeekBox, { bgcolor: "orange.50", borderRadius: "50%", width: 44, height: 44, flexShrink: 0, display: "flex", alignItems: "center", justifyContent: "center" },
        React.createElement(PeekTypography, { variant: "h2", color: "warning.main", display: "flex" },
            React.createElement(AlertTriangle, null))));
};
const CustomSubtopicWarningContent = ({ error }) => {
    const intl = useIntl();
    return (React.createElement(PeekStack, { direction: "column" },
        React.createElement(PeekTypography, { fontWeight: "fontWeightMedium" }, intl.formatMessage(messages.warningTitle)),
        React.createElement(PeekTypography, null, intl.formatMessage(messages.warningDescription)),
        error && (React.createElement(PeekTypography, { color: "error.main", fontWeight: "fontWeightMedium", mt: 0.5 }, intl.formatMessage(messages.createReportError, { message: error })))));
};
const CustomSubtopicWarningAction = ({ onClick, disabled }) => {
    const intl = useIntl();
    return (React.createElement(PeekButton, { size: "large", variant: "outlined", color: "info", startIcon: React.createElement(CopyV2, null), onClick: onClick, disabled: disabled, sx: { whiteSpace: "nowrap" } }, intl.formatMessage(messages.warningActionButton)));
};
export const CustomSubtopicWarning = ({ onConfirm, error, loading } = {}) => {
    const [isDialogOpen, setIsDialogOpen] = useState(false);
    const handleConfirm = onConfirm
        ? () => {
            onConfirm();
            setIsDialogOpen(false);
        }
        : undefined;
    return (React.createElement(React.Fragment, null,
        React.createElement(PeekAlert, { color: "warning", action: onConfirm && React.createElement(CustomSubtopicWarningAction, { onClick: () => setIsDialogOpen(true), disabled: loading }) },
            React.createElement(PeekStack, { width: "100%", direction: "row", alignItems: "center", gap: 2 },
                React.createElement(CustomSubtopicWarningIcon, null),
                React.createElement(CustomSubtopicWarningContent, { error: error }))),
        React.createElement(CustomSubtopicsWarningDialog, { open: isDialogOpen, onClose: () => setIsDialogOpen(false), onConfirm: handleConfirm, loading: loading })));
};
export default CustomSubtopicWarning;
